// Demo build: there is no backend. Every /api request is answered in the
// browser by src/app/demo (DemoApiInterceptor) with fictional data.
export const environment = {
    production: true,
    demo: true,
    env: 'demo',
    apiUrl: '',
    whitelistedDomains: [] as string[],
    blacklistedRoutes: [] as string[],
    recaptcha_site_key: '',
    vapidPubKey: '',
    gaMeasurementId: '',
    support: {
        enabled: true,
        orgName: "NPY Women's Council",
        primaryColor: '#b4532a',
        assistant: {
            enabled: true,
        },
    },
};
